import { SHOW_STICKTOSTER, HIDE_STICYTOSTER,UPDATE_STICKYTOSTER_DATA } from "../Actions/StickyToster.action";
const defaultState = {
  showMessage: false,
  message:"",
  icon:"",
  color:"",
  textcolor:"#003B67"
};

export const StickyToster = (state = defaultState, action) => {
  switch (action.type) {
    case SHOW_STICKTOSTER:
      return {
        ...state,
        ...action.payload,
        showMessage: true,
      };
    case HIDE_STICYTOSTER:
      return {
        ...state,
        ...action.payload,
        showMessage: false,
      };
    case UPDATE_STICKYTOSTER_DATA:
      return {
        ...state,
        message: action.payload.message,
        icon: action.payload.icon,
        color:action.payload.color,
        textcolor:action.payload.textcolor,        
      };
    default:
      return state;
  }
};
